import { render } from "./DefaultLayoutMobile.vue?vue&type=template&id=0d85f000"
import script from "./DefaultLayoutMobile.vue?vue&type=script&lang=js"
export * from "./DefaultLayoutMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__